export default (): ToggleComponent => {

  return {
    on: false,

    init() {
      console.log("init");
    }
  };
};

import { AlpineComponent } from "alpinejs";

type ToggleComponent = AlpineComponent<{
  on: boolean;
}>;
